/* eslint-disable no-console */
// Inspired by @vue/cli-plugin-pwa service worker registration
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.BASE_URL || '/'}service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then(registration => {
        console.log('Service worker registered:', registration.scope);

        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('New content is available; please refresh.');
                } else {
                  console.log('Content is cached for offline use.');
                }
              }
            };
          }
        };
      })
      .catch(err => {
        console.error('Service worker registration failed:', err);
      });
  });
}
